import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FoodIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M6.34999 4V8.86667C6.34999 9.36372 6.75293 9.76667 7.24999 9.76667H7.64999L7.64999 4H9.44999V9.76667H9.84999C10.347 9.76667 10.75 9.36372 10.75 8.86667V4H12.55V8.86667C12.55 10.3578 11.3412 11.5667 9.84999 11.5667H9.44999L9.44999 20H7.64999V11.5667H7.24999C5.75882 11.5667 4.54999 10.3578 4.54999 8.86667V4H6.34999ZM15.95 15.0285V20H14.15L14.15 4H15.95V4.01728C17.889 4.05282 19.45 5.63579 19.45 7.58333V12.9167V13.5067L18.9088 13.742L15.95 15.0285ZM15.95 13.0657L17.65 12.3266V7.58333C17.65 6.62995 16.8948 5.85295 15.95 5.8179L15.95 13.0657Z"
      />
    </SvgIcon>
  );
});
